import React, { Component } from 'react';
import '../../../content/css/PortfolioAnalysis/MultiRangeSlider.css';

export default class MultiRangeSlider extends Component {
    constructor(props) {
        super(props);

        this.state = {
            maxValue: this.props.initialMax,
            minValue: this.props.initialMin
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.initialMin != prevProps.initialMin) {
            this.setState({ minValue: this.props.initialMin });
        }
        if (this.props.initialMax != prevProps.initialMax) {
            this.setState({ maxValue: this.props.initialMax });
        }
    }

    handleChange = (event) => {
        this.props.onChange(this.state.minValue, this.state.maxValue);
    }

    handleMinChange = (event) => {
        const value = Math.min(+event.target.value, this.state.maxValue - 1);
        event.target.value = value.toString();
        this.setState({ minValue: value });
    }

    handleMaxChange = (event) => {
        const value = Math.max(+event.target.value, this.state.minValue + 1);
        event.target.value = value.toString();
        this.setState({ maxValue: value });
    }

    getTrackStyle = () => {
        let minPercent = Math.round(((this.state.minValue - this.props.min) / (this.props.max - this.props.min)) * 100);
        let maxPercent = Math.round(((this.state.maxValue - this.props.min) / (this.props.max - this.props.min)) * 100);;

        return {
            left: `${minPercent}%`,
            width: `${maxPercent - minPercent}%`
        };
    }

    render() {
        let minClass = `thumb thumb--zindex-${this.props.minValue > this.props.maxValue - 100 ? 5 : 3}`;
        return (
            <div className="multi-range-slider">
                <input
                    className={minClass}
                    type="range"
                    min={this.props.min}
                    max={this.props.max}
                    value={this.state.minValue}
                    onChange={this.handleMinChange}
                    onMouseUp={this.handleChange}
                />
                <input
                    className="thumb thumb--zindex-4"
                    type="range"
                    min={this.props.min}
                    max={this.props.max}
                    value={this.state.maxValue}
                    onChange={this.handleMaxChange}
                    onMouseUp={this.handleChange}
                />
                <div className="slider">
                    <span className="slider__title">{this.props.title}</span>
                    <div className="slider__track"></div>
                    <div className="slider__range" style={this.getTrackStyle()}></div>
                    <div className="slider__left-value">{this.state.minValue} days</div>
                    <div className="slider__right-value">{this.state.maxValue} days</div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/AnalysisReports/FilterPanel/MultiRangeSlider.js